export function AboutSection() {
  return (
    <section className="relative py-16 sm:py-20 lg:py-24 bg-white overflow-hidden">
      <div className="absolute top-20 right-0 w-64 h-64 bg-gradient-to-br from-emerald-400/20 to-cyan-400/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-80 h-80 bg-gradient-to-br from-emerald-500/10 to-cyan-500/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                alt="Esaul Lorenzo"
                className="w-full h-auto object-cover"
                src="https://static.readdy.ai/image/45eab4418adfae5cd9f32d2f060296c0/2b71e9ac5881b1b0a3522106f65a8458.png"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-r from-emerald-500 to-cyan-500 text-white px-6 py-4 rounded-2xl shadow-2xl transform rotate-3">
              <div className="text-3xl font-bold">10+</div>
              <div className="text-sm font-medium whitespace-nowrap">Años de Experiencia</div>
            </div>
          </div>

          <div className="space-y-6 order-1 lg:order-2">
            <div className="space-y-4">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight">
                Soy{' '}
                <span className="bg-gradient-to-r from-emerald-500 to-cyan-500 bg-clip-text text-transparent">
                  Esaul
                </span>
              </h2>
              <div className="space-y-4 text-base sm:text-lg text-gray-700 leading-relaxed">
                <p>
                  Tengo <strong className="text-gray-900">10 años dedicado al comercio online</strong> y desde hace{' '}
                  <strong className="text-gray-900">más de 3 años me dedico a la venta de productos digitales</strong>.
                </p>
                <p>
                  He ayudado a <strong className="text-emerald-600">muchos emprendedores a generar ingresos</strong> y mi
                  objetivo es ayudarte a <strong className="text-emerald-600">vivir de este negocio</strong>.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4 pt-6">
              <div className="text-center p-4 rounded-xl bg-gradient-to-br from-emerald-50 to-cyan-50">
                <div className="text-2xl sm:text-3xl font-bold text-gray-900">10</div>
                <div className="text-xs sm:text-sm text-gray-600 whitespace-nowrap">Años Online</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-gradient-to-br from-emerald-50 to-cyan-50">
                <div className="text-2xl sm:text-3xl font-bold text-gray-900">3+</div>
                <div className="text-xs sm:text-sm text-gray-600 whitespace-nowrap">Años Digitales</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-gradient-to-br from-emerald-50 to-cyan-50">
                <div className="text-2xl sm:text-3xl font-bold text-gray-900">500+</div>
                <div className="text-xs sm:text-sm text-gray-600 whitespace-nowrap">Estudiantes</div>
              </div>
            </div>

            <div className="flex flex-wrap gap-4 pt-4">
              <div className="flex items-center gap-2 text-gray-700">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center">
                  <i className="ri-trophy-line text-white text-lg"></i>
                </div>
                <span className="text-sm font-medium whitespace-nowrap">Resultados Comprobados</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center">
                  <i className="ri-heart-line text-white text-lg"></i>
                </div>
                <span className="text-sm font-medium whitespace-nowrap">Pasión por Enseñar</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center">
                  <i className="ri-rocket-line text-white text-lg"></i>
                </div>
                <span className="text-sm font-medium whitespace-nowrap">Estrategias Actualizadas</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
